<!-- 投诉与反馈列表 -->
<template>
	<div class="container">
		<div style="margin-top: 20px;" v-if="complaintLoading">
			<el-skeleton :loading="complaintLoading" animated :rows="10"></el-skeleton>
		</div>
		<div class="complaint-card" v-for="(complaint, index) in complaints" :key="index">
			<!-- 顶部信息栏 -->
			<div class="card-header">
				<div class="header-info" style="align-items: center;">
					<span class="status-tag" v-if="complaint.status=='platform_handled'"
						style="background: #016AF8;color: #fff;">
						{{complaint.statusDesc}}
					</span>
					<span class="status-tag" v-else-if="complaint.status=='cancelled'"
						style="background: #D9001B;color: #fff;">
						{{complaint.statusDesc}}
					</span>
					<span class="status-tag" v-else>
						{{complaint.statusDesc}}
					</span>
					<span class="complaint-number">{{ $t('complaintNumber') }}：{{ complaint.complaintNo }}</span>
				</div>

				<span
					class="complaint-type">{{ $t('complaintType') }}：{{ complaintTypes[complaint.complaintType] }}</span>
				<span class="apply-time">{{ $t('applicationTime') }}：{{ complaint.createTime }}</span>
			</div>

			<!-- 投诉详情 -->
			<div class="complaint-detail">
				<div class="detail-item">
					<span class="label">{{ $t('complaintMerchant') }}：</span>
					<span class="label">{{ complaint.storeName }}</span>
				</div>
				<div class="detail-item" style="font-size: 14px;">
					<span class="label-email">{{ $t('contactEmail') }}：</span>
					<span class="value">{{ complaint.memberEmail }}</span>
				</div>
				<div class="detail-item description">
					<div class="value">{{ complaint.complaintContent }}</div>
				</div>

				<!-- 图片列表 -->
				<div class="image-list">
					<div class="image-item" v-for="(image, imgIndex) in complaint.attachments" :key="imgIndex"
						v-if="image.attachmentStage=='submit'">
						<img :src="image.filePath" @click="handleMagnify(image.filePath)">
					</div>
				</div>

				<!-- 操作按钮 -->
				<div class="action-buttons">
					<!-- 查看审批记录 -->
					<button class="btn btn-secondary" @click="viewApprovalRecords(complaint.id)">
						{{ $t('viewApprovalRecords') }}
					</button>
					<!-- 申请平台介入 -->
					<button class="btn btn-primary" @click="showApplyPlatformIntervertion(complaint.id)"
						v-if="['cancelled','platform_handled','waiting_platform_process'].indexOf(complaint.status)==-1">
						{{ $t('applyPlatformIntervention') }}
					</button>
					<!-- 撤销投诉 -->
					<button class="btn btn-danger" @click="revoke(complaint.id,index)"
						v-if="['cancelled','platform_handled'].indexOf(complaint.status)==-1">
						{{ $t('cancelComplaint') }}
					</button>
				</div>
			</div>
		</div>
		<div class="nodata" v-if="complaints.length==0&&!complaintLoading" style="margin-top: 200px;">
			<img src="/icon/common/nodata.png">
			<span>{{$t('noData')}}</span>
		</div>
		<div class="loading">
			<!-- 加载更多状态 -->
			<div v-if="loadingMore" class="loading-more" style="margin: 30px 0; text-align: center;">
				<i class="el-icon-loading"></i>
				<span>{{$t('dataLoading')}}</span>
			</div>

			<!-- 已加载全部数据 -->
			<div v-if="!hasMore&&complaints.length>0" class="load-all"
				style="margin: 30px 0; text-align: center; color: #999;">
				{{$t('loadingFinish')}}
			</div>
		</div>
		<!-- 查看审批记录 -->
		<el-dialog :title="$t('viewApprovalRecords')" :visible.sync="approvalVisible" width="700px" top="5vh" center
			@close="approvalVisible=false">
			<div class="step-layout">
				<div class="step-container">
					<!-- 加载状态 -->
					<div v-if="replyLoading" class="loading-more" style="margin: 30px 0; text-align: center;">
						<i class="el-icon-loading"></i>
						<span>{{$t('dataLoading')}}</span>
					</div>
					<div class="step-item" v-for="(record, index) in approvalRecords" :key="index">
						<div class="step-marker">
							<div class="marker-circle"></div>
							<div v-if="approvalRecords.length!=index+1" class="marker-line"></div>
						</div>
						<div class="step-content">
							<div class="step-time">{{ record.createTime }}</div>
							<div class="step-title">{{ replyTypes[record.actionType] }}</div>
							<div v-if="record.images.length>0">
								<img v-for="(image,imageIndex) in record.images" :key="imageIndex" :src="image"
									class="step-image" @click="handleMagnify(image)">
							</div>
							<div v-if="record.actionContent" class="step-description">{{ record.actionContent }}</div>
						</div>
					</div>
					<!-- 用户回复内容 -->
					<div style="margin-top: -10px;margin-bottom: 10px;padding-right: 5px;"
						v-if="newStatus=='waiting_user_reply'">
						<el-divider content-position="left">{{$t('userReply')}}</el-divider>
						<el-input type="textarea" v-model="replyContent" :rows="4" :placeholder="$t('replyContent')"
							maxlength="500" show-word-limit></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer" v-if="newStatus=='waiting_user_reply'"
					style="padding-right: 5px;">
					<el-button @click="approvalVisible=false">{{ $t('cancel') }}</el-button>
					<el-button type="primary" @click="submitUserReply"
						:loading="isSubmit">{{ $t('confirm') }}</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 图片放大弹窗 -->
		<el-dialog :visible.sync="magnifyImageVisible" width="700px" top="5vh" center
			@close="magnifyImageVisible=false">
			<img :src="magnifyImage" style="width: 650px;">
		</el-dialog>
		<!-- 申请平台介入，需要填写原因 -->
		<el-dialog :title="$t('applyPlatformIntervention')" :visible.sync="applyPlatformInterventionVisible"
			width="700px" top="5vh" center @close="applyPlatformInterventionVisible=false">
			<el-input type="textarea" v-model="reason" :rows="4" :placeholder="$t('applyPlatformInterventionReason')"
				maxlength="500" show-word-limit></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="applyPlatformInterventionVisible=false">{{ $t('cancel') }}</el-button>
				<el-button type="primary" @click="applyPlatformIntervention"
					:loading="isSubmit">{{ $t('confirm') }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import complaintApi from '@/api/complaint'
	export default {
		name: 'ComplaintList',
		props: {
			searchKeyword: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				replyLoading: true,
				isSubmit: false,
				magnifyImageVisible: false, //图片放大弹窗
				magnifyImage: '', //图片放大地址
				applyPlatformInterventionVisible: false, //申请平台介入弹窗
				complaintId: '',
				reason: '', //申请平台介入原因
				replyContent: '', //用户回复内容
				approvalVisible: false,
				loadingMore: false, // 加载更多的状态
				hasMore: true, // 是否还有更多数据
				isMounted: false, // 组件是否已挂载
				complaints: [],
				complaintLoading: true,
				params: {
					pageNumber: 1,
					pageSize: 10,
				},
				approvalRecords: [], // 审批记录数据
				newStatus: ''
			}
		},
		computed: {
			complaintTypes() {
				return {
					"product": this.$t('productRelated'),
					"store": this.$t('merchantRelated'),
					"service": this.$t('serviceRelated'),
					"other": this.$t('otherIssues')
				};
			},
			replyTypes() {
				return {
					"submit": this.$t('userSubmitComplaint'),
					"merchant_reply": this.$t('storeReply'),
					"user_reply": this.$t('userReply'),
					"user_request_platform": this.$t('userApplyPlatform'),
					"platform_handle": this.$t('platformProcess'),
					"user_cancel": this.$t('userCancelComplaint')
				};
			}
		},
		mounted() {
			// 组件挂载后添加滚动事件监听器
			this.isMounted = true;
			window.addEventListener('scroll', this.handleScroll);
			// 组件销毁时移除滚动事件监听器
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
		},
		methods: {
			//初始化
			init() {
				this.getUserInfo();
				this.complaintLoading = true;
				this.params.pageNumber = 1;
				this.complaints = [];
				this.hasMore = true;
				this.loadingMore = false;
				this.getList();
			},
			//获取登录用户信息
			getUserInfo() {
				this.userInfo = JSON.parse(storage.getUserInfo());
			},
			//获取我的投诉列表
			async getList() {
				var params = {
					...this.params
				}
				if (this.searchKeyword) {
					params.content = this.searchKeyword;
				}
				const res = await complaintApi.getList(params);
				const complaints = res.result.records;

				this.complaintLoading = false;
				// 检查是否是第一页加载
				if (this.params.pageNumber === 1) {
					// 第一页直接替换数据
					this.complaints = complaints;
				} else {
					// 后续页追加数据
					this.complaints = [...this.complaints, ...complaints];
				}

				// 检查是否还有更多数据
				const total = res.result.total;
				if (this.complaints.length >= total) {
					this.hasMore = false;
				}

				// 重置加载状态
				this.loadingMore = false;
			},
			// 加载更多数据
			loadMore() {
				if (this.loadingMore || !this.hasMore) {
					return;
				}
				this.loadingMore = true;
				this.params.pageNumber++;
				this.getList();
			},
			//图片放大功能
			handleMagnify(image) {
				this.magnifyImage = image;
				this.magnifyImageVisible = true;
			},
			// 处理滚动事件
			handleScroll() {
				if (!this.isMounted || this.loadingMore || !this.hasMore) {
					return;
				}
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const clientHeight = document.documentElement.clientHeight || window.innerHeight;
				// 当距离底部小于230px时，加载更多数据
				if (scrollHeight - scrollTop - clientHeight < 230) {
					this.loadMore();
				}
			},
			//撤回投诉
			revoke(id, index) {
				this.$confirm(this.$t('revokeComplaint'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.confirmRevoke(id, index);
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			//确认撤回
			async confirmRevoke(id, index) {
				const res = await complaintApi.cancel(id);
				if (res.code == 200) {
					this.$message.success(this.$t('revokeSuccess'))
					this.complaints.splice(index, 1);
				} else {
					//当前状态不允许撤销投诉
					if (res.code == 4002) {
						this.$message.warning(this.$t('notAllowCancelcomplaint'))
					} else if (res.code == 20005) { //无权操作该投诉
						this.$message.warning(this.$t('NoPermission'))
					} else {
						this.$message.warning(this.$t('revokeFail'))
					}
				}
			},
			//查看审批记录
			async viewApprovalRecords(id) {
				this.newStatus = '';
				this.complaintId = id;
				this.approvalRecords = []
				this.approvalVisible = true;
				this.replyLoading = true;
				const res = await complaintApi.processHistory(id);
				this.approvalRecords = res.result;
				this.approvalRecords.map(item => {
					item.images = [];
					if (item.attachmentCount > 0) {
						item.images = JSON.parse(item.attachmentUrls);
					}
				})
				if (this.approvalRecords.length > 0) {
					this.newStatus = this.approvalRecords[0].newStatus;
				}
				this.replyLoading = false;
			},
			//显示平台介入弹窗
			showApplyPlatformIntervertion(id) {
				this.complaintId = id;
				this.applyPlatformInterventionVisible = true;
			},
			//申请平台介入
			applyPlatformIntervention() {
				if (!this.reason) {
					return this.$message.warning(this.$t('applyPlatformInterventionReason'));
				}
				this.$confirm(this.$t('platformIntervention'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.confirmApplyPlatformIntervention();
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			//确认提交平台介入申请
			async confirmApplyPlatformIntervention() {
				const res = await complaintApi.requestPlatform(this.complaintId, this.reason);
				if (res.code == 200) {
					this.$message.success(this.$t('applySuccess'))
					const targetComplaint = this.complaints.find(item => item.id == this.complaintId);
					if (targetComplaint) {
						targetComplaint.status = "waiting_platform_process";
						targetComplaint.statusDesc = this.$t('waitingPlatformProcess')
					}
					this.$forceUpdate();
				} else {
					//当前状态不允许平台介入
					if (res.code == 4002) {
						this.$message.warning(this.$t('notApplyPlatformIntervention'))
					} else if (res.code == 20005) { //无权操作该投诉
						this.$message.warning(this.$t('NoPermission'))
					} else {
						this.$message.warning(this.$t('applyFail'))
					}
				}
				this.applyPlatformInterventionVisible = false;
				this.reason = '';
			},
			//用户回复
			async submitUserReply() {
				if (!this.replyContent) {
					return this.$message.warning(this.$t('replyContent'));
				}
				this.isSubmit = true;
				const res = await complaintApi.reply(this.complaintId, this.replyContent);
				this.isSubmit = false;
				if (res.code == 200) {
					this.viewApprovalRecords(this.complaintId);
					this.$message.success(this.$t('replySuccess'))
				} else {
					//当前状态不允许回复
					if (res.code == 4002) {
						this.$message.warning(this.$t('notAllowReply'))
					} else if (res.code == 20005) { //无权操作该投诉
						this.$message.warning(this.$t('NoPermission'))
					} else {
						this.$message.warning(this.$t('replyFail'))
					}
				}
			}
		}
	}
</script>

<style scoped>
	.container {
		width: 1200px;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	/* 投诉卡片样式 */
	.complaint-card {
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
		overflow: hidden;
	}

	/* 卡片头部 */
	.card-header {
		background-color: #f9f9f9;
		padding: 15px 20px;
		border-bottom: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #999;
		font-size: 14px;
	}

	.status-tag {
		background-color: #ffeeba;
		color: #856404;
		padding: 4px 12px;
		border-radius: 4px;
		font-size: 14px;
		font-weight: bold;
	}

	.header-info {
		display: flex;
		gap: 20px;
	}

	/* 投诉详情 */
	.complaint-detail {
		padding: 20px;
	}

	.detail-item {
		margin-bottom: 10px;
		display: flex;
		align-items: center;
	}

	.detail-item .label {
		font-weight: bold;
		color: #333;
	}

	.detail-item .label-email {
		color: #999;
	}

	.detail-item .value {
		flex: 1;
		color: #999;
	}

	.detail-item.description {
		margin-bottom: 20px;
	}

	/* 图片列表 */
	.image-list {
		display: flex;
		gap: 10px;
		margin-bottom: 20px;
	}

	.image-item {
		width: 150px;
		height: 150px;
		border: 1px solid #ddd;
		border-radius: 4px;
		overflow: hidden;
	}

	.image-item img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		cursor: pointer;
	}

	/* 操作按钮 */
	.action-buttons {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.btn {
		padding: 8px 16px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		transition: background-color 0.3s;
	}

	.btn-primary {
		background-color: #016AF8;
		color: #fff;
	}

	.btn-primary:hover {
		background-color: #007bff;
	}

	.btn-secondary {
		background-color: #eb8604;
		color: #fff;
	}

	.btn-secondary:hover {
		background-color: #F59A23;
	}

	.btn-danger {
		background-color: #D9001B;
		color: #fff;
	}

	.btn-danger:hover {
		background-color: #f56c6c;
	}

	/* 步骤条样式 */
	.step-layout {
		max-height: 700px;
		overflow: auto;
	}

	.step-container {}

	.step-item {
		display: flex;
	}

	.step-item:last-child {
		margin-bottom: 0;
	}

	.step-marker {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 15px;
	}

	.marker-circle {
		width: 15px;
		height: 15px;
		border: 2px solid #aaa;
		border-radius: 50%;
		background-color: #fff;
	}

	.marker-line {
		width: 2px;
		flex: 1;
		background-color: #aaa;
	}

	.step-content {
		margin-top: -1px;
		padding-bottom: 30px;
		flex: 1;
	}

	.step-time {
		font-size: 14px;
		color: #333;
		font-weight: bold;
		margin-bottom: 4px;
	}

	.step-title {
		font-size: 14px;
		color: #666;
		margin-bottom: 8px;
	}

	.step-description {
		font-size: 14px;
		color: #666;
		background-color: #f5f5f5;
		padding: 8px 12px;
		border-radius: 4px;
	}

	.step-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
		border-radius: 8px;
		margin: 0 5px 5px 0;
		cursor: pointer;
	}

	.dialog-footer {
		display: flex;
		justify-content: right;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	::-webkit-scrollbar {
		width: 2px;
		height: 5px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .3);
	}

	::-webkit-scrollbar-track {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .1);
	}
</style>